module.exports = __webpack_public_path__ + "img/sport_poster.a6f65c40.jpg";